import { useEffect, useState, useMemo } from "react";
import BreadCrumbComp from "../../components/breadCrumb";
import LaddaButton from "../../components/buttons/laddaButton";
import { icons } from "../../constants";
import { Grid, useMediaQuery } from "@mui/material";
import { useNavigate } from "react-router-dom";
import HighchartsComponent from "../../components/highchartsComponent";
import "./styles.css";
import { versusLine } from "../../components/highchartsComponent/charts/lineVersus";
import SimpleTable from "../../components/tables/simpleTable";
import {
  callApiAsync,
  getSelectsServiceOrder,
  getServiceOrdersAnualChartData,
  getDevicesInventoryFilters,
  getEngineeringActivityInfo,
  getSelectsBiomedical
} from "../../services/apiService";
import BiomedicalCard from "../../components/cards/biomedicalCard";
import {
  getCurrentYear,
  getCurrentMonth,
  getYearMonthFromImportDate
} from "../../utils/dateUtils";
import TabComponent from "../../components/tabComponent";
import ManagementDashboardIndicator from "./managementDashboardIndicator";
import SimpleSelect from "../../components/selects/simpleSelect";
import MultiSelect from "../../components/selects/multiSelect";
import { useForm } from "react-hook-form";
import _ from "lodash";
import { pieChard } from "../../components/highchartsComponent/charts/pieChard";
import { API_URL } from "../../config";
import axios from "axios";
import { getCookie } from "../../utils/getCookie";
import { months } from "../../constants/selectData";
import BiomedicalTecnologyAnalisisModal from "./modals/biomedicalTecnologyAnalisisModal";
import { pieChartModelsInstitutions } from "../../components/highchartsComponent/charts/pieChartModelsInstitutions";
import { indicatorTableColumns } from "./columns";
import { useLoadingState } from "../../components/loadingFeedback";

const categoriesData = [
  "Enero",
  "Febrero",
  "Marzo",
  "Abril",
  "Mayo",
  "Junio",
  "Julio",
  "Agosto",
  "Septiembre",
  "Octubre",
  "Noviembre",
  "Diciembre"
];

const BiomedicalManagementDashboard = () => {
  const [loadingInventory, setLoadingInventory] = useLoadingState(true);
  const [loadingAnnual, setLoadingAnnual] = useLoadingState(true);
  const [loadingInfo, setLoadingInfo] = useLoadingState(true);
  const [serviceOrderAnualTable, setServiceOrderAnualTable] = useState([]);
  const userSesion = getCookie("sesion");
  const userId = userSesion.id_usuario;
  const [totalClosed, setTotalClosed] = useState("");
  const [totalOpen, setTotalOpen] = useState("");
  const [created, setCreated] = useState("");
  const [brandFilter, setBrandFilter] = useState([]);
  const [institutionFilter, setInstitutionFilter] = useState([]);
  const [modelFilter, setModelFilter] = useState([]);
  const [producerFilter, setProducerFilter] = useState([]);
  const [stateFilter, setStateFilter] = useState([]);
  const [devicesTable, setDevicesTable] = useState([]);
  const [filteredDevices, setFilteredDevices] = useState([]);
  const [selectedBrand, setSelectedBrand] = useState("");
  const [selectedBrandTotal, setSelectedBrandTotal] = useState(0);
  const [openIndicator, setOpenIndicator] = useState(false);
  const [showSecondChart, setShowSecondChart] = useState(false);
  const [selectedState, setSelectedState] = useState("");
  const [yearOptions, setYearOptions] = useState([]);
  const [dateFilteredDevices, setDateFilteredDevices] = useState([]);
  const [activityInfo, setActivityInfo] = useState([]);
  const [tableType, setTableType] = useState(null);

  const navigate = useNavigate();

  const isSmallScreen = useMediaQuery("(max-width:590px)");
  const isMediumScreen = useMediaQuery("(max-width:900px)");

  const currentYear = getCurrentYear();
  const currentMonth = getCurrentMonth();

  const {
    control,
    formState: { errors },
    getValues,
    watch,
    reset
  } = useForm({
    defaultValues: {
      year: null,
      month: null,
      brand: null,
      mode: []
    }
  });

  const watchActivity = watch("activity");
  const watchMonth = watch("month");

  let buttonHeight = "60px";
  if (isMediumScreen) {
    buttonHeight = "40px";
  } else if (isSmallScreen) {
    buttonHeight = "35px";
  }

  const staticData = [
    {
      objectiveIndicator:
        "Medir el cumplimiento de ejecución de las actividades técnicas asignadas por cada mes",
      responsible: "Coordinador de soporte técnico",
      indicator: "Cumplimiento de las ordenes de servicio asignadas cada mes",
      indexData:
        "(Ordenes de servicio cerradas por mes/ordenes de servicio totales por mes)*100",
      goal: "95%",
      rangeData: "Mensual"
    }
  ];

  const transformDataForPie = (devices) => {
    const groupedByBrand = _.groupBy(devices, "brand_name");

    return Object.keys(groupedByBrand).map((brand) => {
      const devicesByBrand = groupedByBrand[brand];
      const statesCount = _.countBy(devicesByBrand, "state_id");

      return {
        name: brand,
        y: devicesByBrand.length,
        customStates: statesCount
      };
    });
  };

  const graphData = [
    {
      name: "Equipos por marca",
      colorByPoint: true,
      data: transformDataForPie(dateFilteredDevices).map((item) => ({
        ...item,
        events: {
          click: function () {
            setSelectedBrand(this.name);
            setSelectedBrandTotal(this.y);
          }
        }
      }))
    }
  ];

  const getStateName = (id) => {
    const state = stateFilter.find((s) => s.value === id);
    return state ? state.name : id;
  };

  const getEngineeringActivityInfoData = async () => {
    await callApiAsync(
      () => getEngineeringActivityInfo(0, 3),
      (data) => {
        setActivityInfo([data]);
      },
      setLoadingInfo
    );
  };

  const customTooltip = {
    formatter: function () {
      const { customStates } = this.point;
      let statesHtml = "";
      if (customStates) {
        statesHtml = Object.keys(customStates)
          .map((stateId) => {
            const numericId = parseInt(stateId, 10);
            return `<div>${getStateName(numericId)}: <b>${
              customStates[stateId]
            }</b></div>`;
          })
          .join("");
      }

      return `
      <div>
        <b>${this.point.name}</b><br/>
        Total: ${this.y}<br/>
        ${statesHtml}
      </div>
    `;
    },
    useHTML: true
  };

  const getYearOptionsFromDevices = (devices) => {
    const endYear = getCurrentYear();
    const yearSet = new Set();
    yearSet.add(endYear);
    if (Array.isArray(devices)) {
      devices.forEach((d) => {
        const ym = getYearMonthFromImportDate(d?.import_date);
        if (ym) yearSet.add(ym.year);
      });
    }
    const sorted = Array.from(yearSet).sort((a, b) => a - b);
    return sorted.map((y) => ({ value: y, name: String(y) }));
  };

  const normalizeValue = (val) => {
    if (val == null) return null;
    if (typeof val === "object") {
      return val.value ?? val.name ?? val.label ?? null;
    }
    return val;
  };

  const normalizedSelectedState = Array.isArray(selectedState)
    ? selectedState.map((s) => String(s))
    : selectedState
    ? [String(selectedState)]
    : [];

  const totalImportados = devicesTable.length;

  const totalMarcaYEstado = selectedBrand
    ? devicesTable.filter((d) => {
        const okBrand =
          String(d.brand_name).toLowerCase() ===
          String(selectedBrand).toLowerCase();
        const okState =
          normalizedSelectedState.length > 0
            ? normalizedSelectedState.includes(String(d.state_id))
            : true;
        return okBrand && okState;
      }).length
    : 0;

  const brandnumber = dateFilteredDevices.filter(
    (d) => d.brand_name === selectedBrand
  ).length;

  const realValue =
    totalImportados > 0
      ? ((totalMarcaYEstado / brandnumber) * 100).toFixed(2)
      : 0;

  const applyYearMonthFilter = (data, year, month) => {
    return data.filter((d) => {
      const ym = getYearMonthFromImportDate(d.import_date);
      if (!ym) return false;
      const { year: y, month: m } = ym;
      if (y < year) return true;
      if (y === year && m <= month) return true;
      return false;
    });
  };

  const watchYear = watch("year");

const selectedYear = useMemo(() => {
  const y = normalizeValue(watchYear);
  return y ? Number(y) : currentYear;
}, [watchYear, currentYear]);

const selectedMonth = useMemo(() => {
  const m = normalizeValue(watchMonth);
  return m ? Number(m) : currentMonth;
}, [watchMonth, currentMonth]);

const totalImportadosByYearMonth = useMemo(() => {
  const list = applyYearMonthFilter(devicesTable, selectedYear, selectedMonth);
  return list.length;
}, [devicesTable, selectedYear, selectedMonth]);


  const handleFilter = () => {
    const values = getValues();
    const yearVal = normalizeValue(values.year);
    const monthVal = normalizeValue(values.month);

    const effectiveYear = yearVal ? Number(yearVal) : currentYear;
    const effectiveMonth = monthVal ? Number(monthVal) : currentMonth;

    const filterPayload = {
      formValues: { year: values.year, month: values.month, brand: values.brand, mode: values.mode },
      normalized: { year: yearVal, month: monthVal },
      effective: { year: effectiveYear, month: effectiveMonth },
      context: { currentYear, currentMonth, devicesTableLength: devicesTable.length }
    };

    const dateFiltered = applyYearMonthFilter(
      devicesTable,
      effectiveYear,
      effectiveMonth
    );
    setDateFilteredDevices(dateFiltered);
    console.log("[BiomedicalDashboard] Resultado filtro fecha:", {
      effectiveYear,
      effectiveMonth,
      totalDevices: devicesTable.length,
      afterDateFilter: dateFiltered.length
    });

    let result = [...dateFiltered];

    const brandVal = normalizeValue(values.brand);
    if (brandVal) {
      const brandStr = String(brandVal);
      result = result.filter(
        (d) =>
          String(d.brand_id) === brandStr ||
          String(d.brand_name).toLowerCase() === brandStr.toLowerCase()
      );
      const brandName =
        result.length > 0
          ? result[0].brand_name
          : typeof brandVal === "string"
          ? brandVal
          : String(brandVal);
      setSelectedBrand(brandName || "");
      setSelectedBrandTotal(
        devicesTable.filter((d) => d.brand_name === brandName).length
      );
    } else {
      setSelectedBrand("");
      setSelectedBrandTotal(0);
    }

    let modes = values.mode ?? [];
    if (!Array.isArray(modes)) modes = [modes];
    modes = modes
      .map((m) => (typeof m === "object" ? m.value ?? m : m))
      .filter(Boolean);

    if (modes.length) {
      const modesStr = modes.map((m) => String(m));
      result = result.filter((d) => modesStr.includes(String(d.state_id)));
      setSelectedState(modesStr);
    } else {
      setSelectedState([]);
    }

    setFilteredDevices(result);
    setShowSecondChart(Boolean(brandVal && modes.length));
  };

  const handleClearFilters = () => {
    const defaultYear = getCurrentYear();
    const defaultMonth = getCurrentMonth();

    reset({
      brand: null,
      mode: [],
      year: defaultYear,
      month: defaultMonth
    });

    const dateFiltered = applyYearMonthFilter(
      devicesTable,
      defaultYear,
      defaultMonth
    );

    setDateFilteredDevices(dateFiltered);
    setFilteredDevices([]);
    setSelectedBrand("");
    setSelectedBrandTotal(0);
    setSelectedState([]);
    setShowSecondChart(false);
    handleFilter();
  };

  const selectsServiceOrder = async () => {
    await callApiAsync(
      () => getSelectsServiceOrder(),
      () => {}
    );
    setShowSecondChart(false);
  };

  const getFilters = () => {
    callApiAsync(
      () => getDevicesInventoryFilters(userId),
      (data) => {
        setInstitutionFilter(data?.institutionFilter || []);
        setModelFilter(data?.modelFilter || []);
        setProducerFilter(data?.producerFilter || []);
        setBrandFilter(data?.brandFilter || []);
      }
    );
  };

  const getBiomedicalStateOptions = () => {
    callApiAsync(
      () => getSelectsBiomedical(),
      (data) => {
        setStateFilter(data?.state || []);
      }
    );
  };

  const handleCloseIndicator = () => {
    setOpenIndicator(false);
    setTableType(null);
  };

  const handleOpenIndicator = () => {
    setOpenIndicator(true);
  };

  useEffect(() => {
    selectsServiceOrder();
    getFilters();
    getBiomedicalStateOptions();
    getEngineeringActivityInfoData();
  }, []);

  const getServiceOrdersAnualChart = async (year, month) => {
    const effectiveYear = year != null ? Number(year) : getCurrentYear();
    const effectiveMonth =
      month != null &&
      month !== "" &&
      month !== "all" &&
      Number(month) >= 1 &&
      Number(month) <= 12
        ? Number(month)
        : null;

    await callApiAsync(
      () =>
        getServiceOrdersAnualChartData(
          "general",
          effectiveYear,
          null,
          null,
          null,
          null
        ),
      (data) => {
        setServiceOrderAnualTable(data.seriesData || []);
        if (effectiveMonth != null) {
          callApiAsync(
            () =>
              getServiceOrdersAnualChartData(
                "detailed",
                effectiveYear,
                effectiveMonth,
                null,
                null,
                null
              ),
            (detailData) => {
              const detail = detailData.raw?.monthDetail;
              setCreated(detail?.created ?? "");
              setTotalClosed(detail?.closed ?? "");
              setTotalOpen(detail?.open ?? "");
            },
            setLoadingAnnual
          );
        } else {
          setTotalClosed(data.totals?.totalClosedYear ?? "");
          setCreated(data.totals?.totalCreatedYear ?? "");
          setTotalOpen(data.totals?.totalOpenToDate ?? "");
        }
      },
      setLoadingAnnual
    );
  };

  useEffect(() => {
    const rawMonth = normalizeValue(watchMonth);
    getServiceOrdersAnualChart(selectedYear, rawMonth);
  }, [selectedYear, watchMonth]);

  const getDevicesInventory = async () => {
    setLoadingInventory(true);
    try {
      const response = await axios.get(
        `${API_URL}/getDevicesInventory/${userId}`
      );
      const data = response.data;
      setDevicesTable(data);

      const years = getYearOptionsFromDevices(data);
      setYearOptions(years);

      const defaultYear = getCurrentYear();
      const defaultMonth = getCurrentMonth();

      reset({
        brand: null,
        mode: [],
        year: defaultYear,
        month: defaultMonth
      });

      const dateFiltered = applyYearMonthFilter(
        data,
        defaultYear,
        defaultMonth
      );
      setDateFilteredDevices(dateFiltered);

      setFilteredDevices([]);
      setShowSecondChart(false);
    } catch (error) {
      console.error("Error fetching devices:", error);
    } finally {
      setLoadingInventory(false);
    }
  };

  const getModelInstitutionData = (devices) => {
    const modelMap = {};
    devices.forEach((d) => {
      if (!modelMap[d.model]) {
        modelMap[d.model] = {
          total: 0,
          institutions: {}
        };
      }

      modelMap[d.model].total += 1;

      const inst = d.institution_name || "Sin institución";
      modelMap[d.model].institutions[inst] =
        (modelMap[d.model].institutions[inst] || 0) + 1;
    });

    return Object.entries(modelMap).map(([model, data]) => ({
      name: model,
      y: data.total,
      institutions: data.institutions
    }));
  };

  useEffect(() => {
    getFilters();
    getDevicesInventory();
  }, []);

  useEffect(() => {
    handleFilter();
  }, [watchMonth, watchYear]);

  const ToolTipDescription = (text) => {
    return (
      <div>
        <p className="tooltip-text">{text}</p>
      </div>
    );
  };

  const tabData = [
    {
      name: "General",
      id: "0",
      content: (
        <>
          {/* Nueva tabla */}
          <div className="table-container biomedical-indicator-section">
            <div className="HContainer j-space-between a-center">
              <h1 className="title-bio-details-chard">
                Indicador de Tecnología biomédica instalada
              </h1>

              <LaddaButton
                variant="contained"
                onClick={() => {
                  setTableType(3);
                  handleOpenIndicator();
                }}
                margin={0}
                backgroundColor={"#F4D658"}
              >
                <img
                  className="btn-icon"
                  src={icons.analisis_glass_black}
                  alt="icon"
                />
                <span className="text-black" style={{ marginLeft: "5px" }}>
                  Análisis
                </span>
              </LaddaButton>
            </div>
            <br />

            <SimpleTable
              loading={loadingInfo}
              data={activityInfo}
              columns={indicatorTableColumns}
              tooltipFragment={ToolTipDescription}
            />

            <div className="mb-10">
              <form>
                <Grid container spacing={1}>
                  <Grid item xs={12} md={3}>
                    <p className="info-label">Marca</p>
                    <SimpleSelect
                      name="brand"
                      control={control}
                      options={brandFilter}
                      margin={"0"}
                    />
                  </Grid>

                  <Grid item xs={12} md={3}>
                    <p className="info-label">Estado:</p>
                    <MultiSelect
                      name="mode"
                      control={control}
                      options={stateFilter}
                      margin={"0"}
                    />
                  </Grid>
                  <Grid item xs={12} sm={2} md={2}>
                    <p className="info-label">Mes:</p>
                    <SimpleSelect
                      name="month"
                      control={control}
                      label=""
                      options={months}
                      margin={"0"}
                      error={errors.month}
                    />
                  </Grid>
                  <Grid item xs={12} sm={2} md={2}>
                    <p className="info-label">Año:</p>
                    <SimpleSelect
                      name="year"
                      control={control}
                      label=""
                      options={yearOptions}
                      margin={"0"}
                      error={errors.year}
                    />
                  </Grid>
                  <Grid item xs={12} md={1.5}>
                    <div className="IHContainer j-end">
                      <LaddaButton
                        variant="contained"
                        onClick={handleFilter}
                        margin={"43px 0 0 10px"}
                        width={"52px"}
                      >
                        <img
                          className="btn-icon"
                          src={icons.filterWhite}
                          alt="icon"
                        />
                      </LaddaButton>
                      <LaddaButton
                        variant="contained"
                        onClick={handleClearFilters}
                        margin={"43px 0 0 10px"}
                      >
                        <img
                          className="btn-icon"
                          src={icons.clearFilterWhite}
                          alt="icon"
                        />
                      </LaddaButton>
                    </div>
                  </Grid>
                </Grid>

                <div style={{ marginTop: 16 }}>
                  <Grid container spacing={2}>
                    {/* Columna izquierda con la torta */}
                    <Grid item xs={12} md={8}>
                      <HighchartsComponent
                        loading={loadingInventory}
                        options={pieChard(
                          "",
                          "",
                          graphData,
                          [],
                          customTooltip,
                          null,
                          true
                        )}
                      />
                    </Grid>

                    {/* Columna derecha con las tarjetas */}
                    <Grid item xs={12} md={4}>
                      <div
                        className="HContainer j-center a-center"
                        style={{ flexDirection: "column", gap: "20px" }}
                      >
                        <BiomedicalCard
                          loading={loadingInventory}
                          largeText={totalImportadosByYearMonth}
                          smallText="Total General"
                          bgColor="#FFF6E5"
                        />

                        {selectedBrand && (
                          <BiomedicalCard
                            loading={loadingInventory}
                            largeText={
                              dateFilteredDevices.filter(
                                (d) => d.brand_name === selectedBrand
                              ).length
                            }
                            smallText={`Total Marca ${selectedBrand}`}
                            bgColor="#DDF3FF"
                          />
                        )}
                      </div>
                    </Grid>
                  </Grid>
                </div>

                {showSecondChart && (
                  <div style={{ marginTop: 16 }}>
                    <Grid container spacing={2}>
                      <Grid item xs={12} md={8}>
                        <HighchartsComponent
                          loading={loadingInventory}
                          options={pieChartModelsInstitutions(
                            getModelInstitutionData(filteredDevices),
                            true
                          )}
                        />
                      </Grid>
                      {/* Columna derecha: tarjetas */}
                      <Grid item xs={12} md={4}>
                        <div
                          className="HContainer j-center a-center"
                          style={{ flexDirection: "column", gap: "20px" }}
                        >
                          {/* Tarjeta 1: Total equipos en estado seleccionado */}
                          <BiomedicalCard
                            largeText={
                              dateFilteredDevices.filter(
                                (d) => d.brand_name === selectedBrand
                              ).length
                            }
                            smallText={`Total Marca ${selectedBrand}`}
                            bgColor="#DDF3FF"
                          />
                          <BiomedicalCard
                            largeText={filteredDevices.length}
                            smallText={`Total equipos en estado ${
                              selectedState && selectedState.length > 0
                                ? selectedState
                                    .map((id) => getStateName(Number(id)))
                                    .join(", ")
                                : "N/A"
                            }`}
                            bgColor="#FFF6E5"
                          />

                          {/* Tarjeta 2: Total instituciones */}
                          <BiomedicalCard
                            largeText={
                              new Set(
                                filteredDevices.map((d) => d.institution_name)
                              ).size
                            }
                            smallText="Total Instituciones Únicas"
                            bgColor="#DDF3FF"
                          />

                          {/* Tarjeta 3: Real */}
                          <BiomedicalCard
                            largeText={`${realValue}%`}
                            smallText="Real"
                            bgColor="#F4D658"
                          />
                        </div>
                      </Grid>
                    </Grid>
                  </div>
                )}
              </form>
            </div>
          </div>

          <div className="table-container biomedical-indicator-section">
            <div className="j-center">
              <h1 className="title-bio-details-chard">
                Indicador General de Cumplimiento de Ordenes de Servicio
              </h1>
              <br />
            </div>
            <SimpleTable
              loading={loadingAnnual}
              data={staticData}
              columns={indicatorTableColumns}
              tooltipFragment={ToolTipDescription}
            />
            <div className="HContainer j-center a-center">
              <div
                style={{
                  display: "flex",
                  flexWrap: "wrap",
                  justifyContent: "center",
                  alignItems: "stretch"
                }}
              >
                <div>
                  <BiomedicalCard
                    loading={loadingAnnual}
                    largeText={` ${created ?? created + " creadas"} `}
                    smallText="Total de Ordenes creadas"
                    width={"200px"}
                  />
                </div>
                <div>
                  <BiomedicalCard
                    loading={loadingAnnual}
                    largeText={` ${totalClosed ?? totalClosed + " cerradas"} `}
                    smallText="Total de Ordenes Cerradas"
                    width={"200px"}
                    bgColor="#DDF3FF"
                  />
                </div>
                <div>
                  <BiomedicalCard
                    loading={loadingAnnual}
                    largeText={totalOpen ?? totalOpen}
                    smallText="Total de Ordenes abiertas"
                    width={"200px"}
                  />
                </div>
              </div>
            </div>
            <div style={{ marginTop: 16 }}>
              <HighchartsComponent
                loading={loadingAnnual}
                options={versusLine(
                  "",
                  "",
                  "Cantidad de ordenes de servicio",
                  serviceOrderAnualTable,
                  categoriesData,
                  "Meses"
                )}
              />
            </div>
          </div>
        </>
      )
    },
    {
      name: "Detalle",
      id: "1",
      content: (
        <>
          <ManagementDashboardIndicator />
        </>
      )
    }
  ];

  return (
    <div>
      <BreadCrumbComp />
      <Grid container spacing={2}>
        <Grid item xs={12} sm={12} md={4}>
          <LaddaButton
            variant="contained"
            onClick={() => {
              navigate("/biomedicalManagementDashboard/manageDevice", {
                state: { type: "maintenance", data: {} }
              });
            }}
            height={buttonHeight}
            borderRadius={"15px"}
            width={"100%"}
          >
            <div className="IHContainer align-center">
              <img
                className="btn-icon"
                src={icons.pcMonitor}
                alt="icon"
                style={{ marginRight: "10px" }}
              />
              <p className="button_text">Inventario de equipos biomédicos</p>
            </div>
          </LaddaButton>
        </Grid>
        <Grid item xs={12} sm={12} md={4}>
          <LaddaButton
            variant="contained"
            color={"#404040"}
            backgroundColor={"#F4D658"}
            onClick={() => {
              navigate("/biomedicalManagementDashboard/BioMedicalRequest", {
                state: { type: "maintenance", data: {} }
              });
            }}
            width={"100%"}
            borderRadius={"15px"}
            height={buttonHeight}
          >
            <div className="IHContainer align-center">
              <img
                className="btn-icon"
                src={icons.verificationList}
                alt="icon"
                style={{ marginRight: "10px" }}
              />
              <p className="button_text">Crear Orden de Servicio</p>
            </div>
          </LaddaButton>
        </Grid>
        <Grid item xs={12} sm={12} md={4}>
          <LaddaButton
            variant="contained"
            onClick={() => {
              navigate("/biomedicalManagementDashboard/serviceRecords", {
                state: { type: "maintenance", data: {} }
              });
            }}
            height={buttonHeight}
            borderRadius={"15px"}
            width={"100%"}
          >
            <div className="IHContainer align-center">
              <img
                className="btn-icon"
                src={icons.contract}
                alt="icon"
                style={{ marginRight: "10px" }}
              />
              <p className="button_text">Llenar Reporte de Ingeniería</p>
            </div>
          </LaddaButton>
        </Grid>
      </Grid>
      <div className="searchTitle">
        <h1>DASHBOARD - GESTIÓN BIOMÉDICA</h1>
      </div>
      <TabComponent panels={tabData} variant={"fullWidth"} />
      <BiomedicalTecnologyAnalisisModal
        open={openIndicator}
        handleClose={handleCloseIndicator}
        data={watchActivity || null}
        tableType={tableType}
      />
    </div>
  );
};

export default BiomedicalManagementDashboard;
